export enum MultipostingProvider {
  CATCH = 'catch',
  GOHIRING = 'gohiring',
  VONQ = 'vonq',
}